

class inputHandler {

  constructor(settings) {
    this.master = settings.master
      ? this.registerData(settings.master)
      : null;
    this.stateUpdate = settings.stateUpdate;
    this.updateStore = {};
    this.data = null;
    this.options = {
      pixelPerCharacter: 6,
      minHeaderWidth: 120,
      ...settings.options
    }
    this.pageLimit = 30;
    this.page = 0;
    this.pageTotal = () => this.data.length / this.pageLimit;
    this.headers = [];
    this.tableWidth = settings.tableWidth;
    this.tableElement = settings.tableElement;
    this.negativeSpace = 0;
    this.groupActions = settings.groupActions;
    this.group = [];
    this.registryCount = 0;
    this.searchingHeader = null;
    this.searchActive = false;
    this.globalSearchQuery = '';
    this.sortIndex = {index: null, toBottom: false}
    this.queryString = '';
    this.userSetColumns = settings.userSetColumns;
    this.tableID = settings.tableInstanceID;
    this.tipIndex = null;
    this.groupMenuActive = false;
    this.headerInput = {
      headers: settings.headers,
      settings: settings.headerSettings,
      currentHeaders: null,
      excludedHeaders: [],
    }
  }

  // =============================================== Generate Headers
  generateHeaders() {
    // console.log('=====> Header Generation');
    const data = this.data
      ? this.data.map(dataID => this.master[dataID])
      : this.master ? Object.values(this.master) : null;
    // generate headers
    if (data && this.headerInput && this.headerInput.headers === null) {
      // console.log(settings.input)
      data.forEach(dataObj => {
        Object.keys(dataObj).forEach(header => {
          const headerCheck = this.headers.map(headerObj => {
            return headerObj.id;
          });
          if (!headerCheck.includes(header)) this.headers.push({
            title: header,
            id: header,
            searchable: true,
          });
        })
      })
    } else {
      // header initialization
      this.headers = this.headerInput.headers.map(headerID => {
        const headerSettings = this.headerInput.settings[headerID];
        return {
          title: headerSettings.title,
          id: headerID,
          searchable: headerSettings.searchable,
          tip: headerSettings.tip,
          key: headerSettings.key,
          width: headerSettings.width,
          minWidth: headerSettings.minWidth
        };
      });
      if (this.groupActions) {
          this.headers.unshift({
            title: '',
            id: 'dt_group_checkbox',
            searchable: false,
            sortable: false,
            tip: false,
            key: '',
            width: 45,
        })
      }
    }

    // filter headers
    this.filteredHeaders = this.headers
      .filter(headerObj => !this.headerInput.excludedHeaders.includes(headerObj.id));
    this.headerInput.currentHeaders = this.filteredHeaders.map(headerObj => headerObj.id);

  }


  // ======================================== Toggle Headers
  headerChange(id) {
    this.headerInput.excludedHeaders.includes(id)
    ? this.headerInput.excludedHeaders = this.headerInput.excludedHeaders.filter(exID => exID !== id)
    : this.headerInput.excludedHeaders.push(id);
  }



  // ========================================== Column Caluculation
  calculateColumns() {
    // console.log('=====> Column Calculation');
    // use width setting(min/max) to calculate number of rows each header should use
    const targetHeaders = this.filteredHeaders || this.headers;
    const colCount = this.userSetColumns ? this.userSetColumns
    : targetHeaders.length > 10 ? targetHeaders.length
    : (targetHeaders.length <= 7 ? targetHeaders.length + 3 : 10);

    // single column width, if header count is greater than twelve use header count
    const colWidth = 100 / colCount;
    let headers = { info: [], min: [], max: [], cust: 0 };

    targetHeaders.forEach(headObj => {
      headers.info.push({id: headObj.id, width: headObj.width});
      if (headObj.width === 'max') headers.max.push(headObj.id)
      else if (headObj.width === 'min') headers.min.push(headObj.id)
      else headers.cust += headObj.width;
    })

    // check for max width headers
    const hasMaxHeaders = headers.max.length > 0;

    let stretchCols = hasMaxHeaders
      // remove 1 column for each min header, divide rest between max headers
      ? (colCount - headers.min.length) / (headers.max.length || 1)
      : colCount / headers.min.length;

    // spread width values over header objects
    let totalWidth = 0;
    targetHeaders.forEach((headerObj, i) => {
      const minHeaderWidth = headerObj.id === 'dt_group_checkbox' ? 64 : this.options.minHeaderWidth;

      const widthType = headerObj.width;
      const header = (this.filteredHeaders || this.headers)[i];
      let minPixelWidth;
      // calculate col width in percentage based on how many columns it is set to have
      if (widthType === 'min' && hasMaxHeaders) {
        // min columns get one column - 40 = 30(sidbarwidth) + 15(lineNumebr width)
        const headerPixelWidth = (this.tableWidth - headers.cust - 45) * (colWidth / 100);
        header.widthValue = (headerPixelWidth < minHeaderWidth ? minHeaderWidth : headerPixelWidth.toFixed(3)) + 'px';

      } else if (widthType === 'max' || (widthType === 'min' && !hasMaxHeaders)) {
        // max columns will divide the leftover columns amongst themselves

        const width = (colWidth * stretchCols)
          // + (remainder ? (colWidth * remainder) : 0);

        // set max string length for this cell width - 40 = 30(sidbarwidth) + 15(lineitem width)
        const headerPixelWidth = (this.tableWidth - headers.cust - 45) * (width / 100);
        if (header.minWidth) minPixelWidth = (this.tableWidth - headers.cust - 45) * (width / 100)
        header.widthValue = (headerPixelWidth < minHeaderWidth ? minHeaderWidth : headerPixelWidth.toFixed(3)) + 'px';

      } else {
        this.negativeSpace = headers.cust;
        header.widthValue = (header.width || minHeaderWidth) + 'px';
      }
      if (header.minWidth && parseInt(header.widthValue) < header.minWidth) {
        header.widthValue = header.minWidth + 'px';
      }
      // header string length factor
      // -- header width minus 16px to account for cell padding, divided by pixelPerCharacter configuration.
      header.maxStringLength = Math.floor((parseFloat(header.widthValue) - 14) / this.options.pixelPerCharacter)
      totalWidth += parseFloat(header.widthValue);
    })
    this.headersTotalWidth = Math.floor(totalWidth);
    this.colsHaveCalculated = true;
  }

  // ================================================================== Catalog Data
  registerData(dataInput) {
    this.registryCount++;
    this.master = {};
    const input = !Array.isArray(dataInput) ? [dataInput] : dataInput;
    input.forEach((data, index) => {
      this.master['dtData' + index] = data;
    })
    this.data = Object.keys(this.master);
  }

  // ================================================================== Search Filter Method
  queryData(string) {
      // console.log('=====> Query Data');
      this.queryString = string;
      const headerKey = this.headers[this.searchingHeader].key;

      // const filteredData = (this.updateStore.tableData ? this.updateStore.tableData : this.data)
      const filteredData = this.data.map(dataID => {
        let obj = {...this.master[dataID]};
        obj.dt_data_identifier = dataID;
        return obj;
      })
      .map(obj => {
        return obj[headerKey] && obj[headerKey].toString().toLowerCase().includes(string.toLowerCase())
          ? obj.dt_data_identifier : null;
      })
      .filter(item => item !== null);
      // update dataTable
      this.filteredData = filteredData;
      this.pagifyData();
  }

  // ================================================================== gloabl search Filter Method

  globalQueryData(value) {
    this.globalSearchQuery = value.toLowerCase();
    const filteredData = this.data.map(dataID => {
      let obj = {...this.master[dataID]};
      obj.dt_data_identifier = dataID;
      return obj;
    })
    .map(obj => {
      let match = false;
      Object.values(obj)
      .filter(val => val !== obj.dt_data_identifier)
      .map(val => typeof val === 'string' ? val : JSON.stringify(val))
      .forEach(val => {
        if (!match) {
          if (val.toLowerCase().includes(value)) match = true;
        }
      })
      return match ? obj.dt_data_identifier : null
    })
    .filter(item => item !== null);
    this.filteredData = filteredData;

    this.pagifyData();
    this.render();
  }

  // ================================================================== Sort Data by Header
  sortData(headerIndex) {
    let key, toBottom;
    this.headers.forEach((obj, index) => {
      obj.sort = headerIndex === index ? true : false;
      if (headerIndex === index) {
        toBottom = index === this.sortIndex.index ? !this.sortIndex.toBottom : true;
        key = obj.key;
        this.sortKey = `${index}-${obj.toBottom}`;
      }
    })

    let dataSet = {};
    if (this.filteredData) {
      this.filteredData.forEach(dataID => dataSet[dataID] = this.master[dataID])
    } else dataSet = this.master;

    const origData = (Object.keys(dataSet))
    .map(dataID => {
      return {...dataSet[dataID], dt_data_sort_id: dataID}
    }).slice()
    .map((dataObj, i) => {
      let obj = {...dataObj};
      obj.dt_sort_key = i;
      return obj;
    });

    const sortData = origData.slice().map(dataObj => {
      return {
        value: dataObj[key],
        sortKey: dataObj.dt_data_sort_id,
      };
    }).sort((obj1,obj2) => {
      return obj1.value < obj2.value ? (toBottom ? -1 : 1)
        : obj1.value > obj2.value ? (toBottom ? 1 : -1)
        : 0;
    });

    const finalSort = sortData.map(sortObj => sortObj.sortKey);

    this[this.globalSearchQuery ? 'filteredData' : 'data'] = finalSort;
    this.sortIndex = {
      index: headerIndex,
      toBottom: toBottom,
    };
    this.pagifyData();
    if (this.queryString !== '') this.queryData(this.queryString);
  }


  // ====================================================================== Pagify Method
  pagifyData(modularInput=false) {
    // console.log('=====> Pagify Data');
    const startIndex = this.page ? this.page * this.pageLimit : 0;

    const pagifiedData = (modularInput || this.filteredData || this.data || this.master && Object.keys(this.master))
    .slice(
      startIndex,
      startIndex + this.pageLimit,
    )

    this.updateStore.tableData = pagifiedData;
  }

  // ====================================================================== reset data
  reset() {
    this.updateStore = {tableData: Object.keys(this.master)};
    this.filteredData = null;
    this.queryString = '';
    this.globalSearchQuery = '';
    this.data = this.sortIndex.index !== null ? this.data : Object.keys(this.master);
    // this.searchingHeader = null;
    this.pagifyData();
    this.render();
  }

  // ====================================================================== Group Menu View
  setGroupMenuActive(render=true) {
    this.groupMenuActive = true;
    if (render) this.render(true);
  }
  setGroupMenuInactive(render=true) {
    this.groupMenuActive = false;
    if (render) this.render(true);
  }


  // ====================================================================== Grups & Spreads

  addToGroup(dataID) {
    this.group.push(dataID);
    this.render(true);
  }
  removeFromGroup(dataID) {
    this.group = this.group.filter(id => dataID !== id);
    this.render(true);
  }
  addAllToGroup() {
    this.group = this.filteredData || Object.keys(this.master);
    this.setGroupMenuInactive(false);
    this.render(true);
  }
  clearGroup() {
    this.setGroupMenuInactive(false);
    this.group = [];
    this.render(true);
  }

  // ====================================================================== tips
  setTip(index) {
    this.tipIndex = index;
    this.render(true);
  }
  clearTip() {
    this.tipIndex = null;
    this.render(true);
  }
  // ====================================================================== Render Method
  render(auto=false) {

    if (auto) {

      this.generateHeaders();

      // if (this.master
      // && this.data.length === this.master.length
      // && this.master.length > this.pageLimit) this.pagifyData();
      this.pagifyData();
    }

    this.calculateColumns();
    // this.domEffects();

    if (Object.keys(this.updateStore).length) {
      // console.log('===== DT Controller Render Full =====')
      this.stateUpdate(this.updateStore);
    } else {
      // console.log('===== DT Controller Render =====')
    }
    this.updateStore = {};
  }






} // inputHandler end






const dataTableController = (settings) => {

  //--- Controller Mount
  const controller = new inputHandler(settings);



  return controller;
}



export default dataTableController;
